/* ==========================================================================
   AURA — QUANTITY STEPPER
   Pure UI: clamps min/max locally and emits a bubbling `aura:quantity-change`
   event (detail: { value }) on every committed change. Knows nothing about
   carts, forms, or transports — host controllers listen for the event.
   ========================================================================== */
(function () {
  'use strict';

  class AuraQuantityStepper {
    constructor(root) {
      this.root = root;
      this.input = root.querySelector('[data-qty-input]');
      this.minus = root.querySelector('[data-qty-minus]');
      this.plus = root.querySelector('[data-qty-plus]');
      if (!this.input) return;

      this.lastValue = this.clamp(this.input.value);
      this.refreshState();

      if (this.minus) this.minus.addEventListener('click', () => this.step(-1));
      if (this.plus) this.plus.addEventListener('click', () => this.step(1));
      this.input.addEventListener('change', () => this.commit(this.input.value));
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.commit(this.input.value);
          this.input.blur();
        }
      });
    }

    clamp(raw) {
      const min = parseFloat(this.input.min);
      const max = this.input.max !== '' ? parseFloat(this.input.max) : null;
      let v = Math.round(parseFloat(raw));
      if (isNaN(v)) v = isNaN(min) ? 1 : min;
      if (!isNaN(min)) v = Math.max(min, v);
      if (max != null && !isNaN(max)) v = Math.min(max, v);
      return v;
    }

    step(dir) {
      const step = parseFloat(this.input.step) || 1;
      const current = parseFloat(this.input.value) || 0;
      this.commit(current + dir * step);
    }

    refreshState() {
      const min = parseFloat(this.input.min);
      const max = this.input.max !== '' ? parseFloat(this.input.max) : null;
      const value = parseFloat(this.input.value);
      if (this.minus) this.minus.disabled = !isNaN(min) && value <= min;
      if (this.plus) this.plus.disabled = max != null && value >= max;
    }

    commit(rawValue) {
      const value = this.clamp(rawValue);
      this.input.value = value;
      this.refreshState();
      if (value === this.lastValue) return;
      this.lastValue = value;
      this.root.dispatchEvent(
        new CustomEvent('aura:quantity-change', { bubbles: true, detail: { value } })
      );
    }
  }

  function init() {
    document.querySelectorAll('[data-aura-quantity-stepper]').forEach((root) => {
      if (root.dataset.auraReady) return;
      root.dataset.auraReady = '1';
      new AuraQuantityStepper(root);
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  /* Host controllers call this after replacing DOM (AJAX cart re-render, etc.)
     so freshly-inserted steppers get bound without a full reload. */
  window.AuraQuantityStepper = { init };
})();
